<template>
  <div class="viewDashBoard" v-cloak>
    <div class="">
      <div
        v-if="
          typeof getActiveUserData.user !== 'undefined' &&
            Object.keys(getActiveUserData.user).length
        "
      >
        <create-role-vue
          v-if="getActiveUserData.userRoles == 'admin'"
        ></create-role-vue>
        <not-found v-else></not-found>
      </div>
      <div v-else class="white-row loader-route">
        <div class="lds-sub-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import create_role from "./create/create";
import noComponent from "../../components/noComponentFound";

export default {
  components: {
    "create-role-vue": create_role,
    "not-found": noComponent
  },
  computed: {
    getActiveUserData() {
      return this.$store.state.auth;
    }
  },
  data() {
    return {};
  },
  mounted() {
    document.title = this.$router.app._route.meta.pageTitle;
  },
  methods: {}
};
</script>
